import * as API from '.'

let url = 'api/autoTypeset/';

export default {
    getAutoTypesetTaskById:params=>{
        return API.POST( url + 'getAutoTypesetTaskById', params)
    },
    getAutoTypesetTasks: params => {
        return API.POST( url + 'getAutoTypesetTasks', params)
    },
    downloadFile: params => {
        return API.O_POST( url + 'downloadFile', params,{responseType:'blob'})
    },
    insert: params => {
        return API.POST( url + 'insert', params)
    },
    startTranformation: params => {
        return API.POST( url + 'startTranformation', params)
    },
    deleteTask:params => {
        return API.POST( url + 'deleteTask', params)
    },
    getTaskLog:params => {
        return API.POST( url + 'getTaskLog', params)
    },
    getTypesetJournalList:params => {
        return API.POST( url + 'getTypesetJournalList', params)
    },
}


// WEBPACK FOOTER //
// ./src/api/api_autoTypeset_task.js